import { render, staticRenderFns } from "./NumerationsConfig.vue?vue&type=template&id=75db72e4"
import script from "./NumerationsConfig.vue?vue&type=script&lang=js"
export * from "./NumerationsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports